package com.eladfinish.bible.contest.ui.components.toolbar.configuration.ext

import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionVisibility

internal fun <TId : Enum<TId>> ToolbarActionConfig<TId>.isVisible(isDebug: Boolean = false): Boolean {
    return when (val v = visibility) {
        ToolbarActionVisibility.Always -> true
        ToolbarActionVisibility.Never -> false
        ToolbarActionVisibility.DebugOnly -> isDebug
        is ToolbarActionVisibility.Predicate -> v.isVisible()
    }
}

fun <TId : Enum<TId>> ToolbarActionConfig<TId>.withEnabled(enabled: Boolean): ToolbarActionConfig<TId> =
    when (this) {
        is ToolbarActionConfig.IconAction -> copy(enabled = enabled)
        is ToolbarActionConfig.TextActionRes -> copy(enabled = enabled)
        is ToolbarActionConfig.TextAction -> copy(enabled = enabled)
        is ToolbarActionConfig.SubMenu<TId> -> copy(enabled = enabled)
        is ToolbarActionConfig.CheckboxActionRes<TId> -> copy(enabled = enabled)
    }
